import axios from 'axios'

export const companiesRegistrationsProgresses = {
  namespaced: true,
  state: {
    data: {
      kind: 0
    },
    loading: false,
    loadError: false,
    errors: null,
  },
  mutations: {
    writeCompaniesRegistrationsProgresses(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    registrationDoneSuccess(state, payload) {
      state.data = payload
      state.loading = false
    },
    registrationDoneFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    },
  },
  actions: {
    writeCompaniesRegistrationsProgresses({ commit }, { companyUuid, kind }) {
      commit('writeCompaniesRegistrationsProgresses')
      const payload = {
        kind: kind
      }
      return axios
        .post('/api/companies/'+ companyUuid +'/registrations/progresses', payload)
        .then(() => {
          commit('registrationDoneSuccess', payload)
          return true
        })
        .catch(err => {
          commit('registrationDoneFailure', err)
          console.error(err)
        })
    },
  }
}